import React from 'react';
import { SText } from 'src/components/SText';

type Props = {
  testID?: string;
  label: string;
};

export const SubTitle: React.FC<Props> = ({ label }) => {
  return <SText label={label} classNames="my-2 text-gray-800 font-regular text-lg block" />;
};
